export default __webpack_public_path__ + "static-bigflip/media/selfie.21392cb8.png";